(() => {
  const root = window.Shopify?.routes?.root || '/';
  function refreshOffer(offer) {
    if (!offer) return;
    const checkbox = offer.querySelector('[data-vipa-screenwash-choice]');
    if (!checkbox) return;
    const productForm = offer.closest('product-form');
    const label = productForm?.querySelector('[data-vipa-screenwash-button-label]');
    if (label) {
      label.textContent = checkbox.checked ? offer.dataset.vipaCtaWith : offer.dataset.vipaCtaWithout;
    }
    const fastCheckout = productForm?.querySelector('.shopify-payment-button');
    if (fastCheckout) fastCheckout.hidden = checkbox.checked;
    offer.classList.toggle('is-selected',checkbox.checked);
  }
  function init() {
    document.querySelectorAll('[data-vipa-screenwash-offer]').forEach(refreshOffer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('[data-vipa-screenwash-choice]');
    if (checkbox) refreshOffer(checkbox.closest('[data-vipa-screenwash-offer]'));
  });
  document.addEventListener('click', (event) => {
    const skip = event.target.closest('[data-vipa-screenwash-skip]');
    if (!skip) return;
    event.preventDefault();
    skip.closest('[data-vipa-screenwash-cart-offer]')?.setAttribute('hidden','');
  });
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vipa-screenwash-cart-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    button.disabled = true;
    const oldText = button.textContent;
    button.textContent = button.dataset.loadingText || oldText;
    const error = button.closest('.vipa-screenwash')?.querySelector('[data-vipa-screenwash-error]');
    if (error) {error.hidden = true;error.textContent = '';}
    try {
      const response = await fetch(button.dataset.cartAddUrl + '.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})
      });
      const payload = await response.json();
      if (!response.ok || payload.status) throw new Error(payload.description || payload.message || button.dataset.errorText);
      window.location.assign(root+'cart');
    } catch (failure) {
      if (error) {error.hidden=false;error.textContent=failure.message||button.dataset.errorText;}
      button.disabled=false;
      button.textContent=oldText;
    }
  });
})();
